module.exports = __webpack_public_path__ + "static/logo-white-f1abf94c489dc7b4325f27f3947314c7.svg";